import { Navigate } from 'react-router-dom';
import { AppRoutes } from 'shared';
import { PaymentQueryKeys } from 'features/payments/constants';

export const PaymentsSuccessRedirect = () => {
  return <Navigate to={`${AppRoutes.root()}?${PaymentQueryKeys.SHOW_SUCCESS}=1`} />;
};
